<template>
  <div id="app">
  <!-- Loader starts-->
    <!-- <div class="loader-wrapper" :class="{'loderhide' : !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div> -->
  <!-- Loader ends-->

    <!--<Main/>-->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
  export default {
    name: 'app',
    data(){
      return{
        show: true,
      };
    },
    async mounted() {
      this.timeOut();
      await this.getDuplicateTransactionPeriod()
    },
    methods:{
      ...mapActions('transfers', ['getDuplicateTransactionPeriod']),
      timeOut(){
        var self = this;
        setTimeout(function(){
          self.show = false;
        }, 1000);
      }
    }
  };
</script>

<style>
.page-wrapper .page-body-wrapper .page-body{
  padding: 0 !important;
}
* {
  font-family: 'Open Sans', sans-serif;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span,
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links>li .sidebar-submenu li a {
  font-family: 'Open Sans', sans-serif !important;
}
.loader-wrapper.loderhide {
  display: none;
}
.show {
  margin-top: 0 !important;
}
circle:last-child {
  cx: 120 !important;
}
.vdp-datepicker >>> .form-control {
  border-left: 0px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.input-group-text {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: 0 !important;
}
</style>
